import request from '@/utils/request'
import {config} from "@/utils/shengwangLive"

export function createRoom(data, roomUuid) {
    return request({
        url: `/${config.region}/edu/apps/${config.appId}/v2/rooms/${roomUuid}`,
        method: 'POST',
        data: data
    })
}

export function getRoom(roomUuid) {
    return request({
        url: `/${config.region}/edu/apps/${config.appId}/v2/rooms/${roomUuid}`,
        method: 'get',
    })
}


export function historyRoom(roomUuid) {
    return request({
        url: `/edu/v2/rooms/${roomUuid}/history`,
        method: 'get',
    })
}

export function getUser(roomUuid,userUuid) {
    return request({
        url: `/${config.region}/edu/apps/${config.appId}/v2/rooms/${roomUuid}/users/${userUuid}`,
        method: 'get',
    })
}

export function getUserList(roomUuid) {
    return request({
        url: `/${config.region}/edu/apps/${config.appId}/v2/rooms/${roomUuid}/sequences?cmd=20`,
        method: 'get',
    })
}

export function getUserListHor(roomUuid) {
    return request({
        url: `/${config.region}/edu/apps/${config.appId}/v2/rooms/${roomUuid}/history`,
        method: 'get',
    })
}


